import React, {
	createContext,
	useContext,
	useMemo,
	memo,
	type ReactNode,
	type RefObject,
	type RefCallback,
} from 'react';

export type TableRefContext = {
	tableRef?: RefObject<HTMLTableElement | null> | RefCallback<HTMLTableElement>;
};

const defaultTableRefContext: TableRefContext = {
	tableRef: undefined,
};

const TableRefContext = createContext<TableRefContext>(defaultTableRefContext);

export const useTableRefContext = () => useContext(TableRefContext);

type Props = Partial<TableRefContext> & {
	children: ReactNode;
	isSinleLineRowHeightEnabled: boolean;
};

export const TableRefContextProvider = memo(
	({ children, isSinleLineRowHeightEnabled, ...props }: Props) => {
		const context = useMemo(() => ({ ...defaultTableRefContext, ...props }), [props]);
		return isSinleLineRowHeightEnabled ? (
			<TableRefContext.Provider value={context}>{children}</TableRefContext.Provider>
		) : (
			children
		);
	},
);
